import type { PublicationFetchForTopicPayload } from "entities/publication/actionTypes";

export const getPublicationFetchParams = ({
  fromTime,
  language,
  limit,
  offset,
  publication_type,
  search,
  secondaryTopicId,
  toTime,
}: Partial<PublicationFetchForTopicPayload>) => ({
  ...(language && { language }),
  ...(publication_type && { publication_type }),
  ...(search && { search }),
  from_time: fromTime,
  limit,
  offset,
  to_time: toTime,
  topics: secondaryTopicId ? [secondaryTopicId] : [],
});
